import { AgentModel, AppApi } from '@/customApiClients/appApiClient/Api';

import { queueAgentSelectionPersist } from './agentSelectionGate';

export interface ManagedAgentDbConfig {
    organization: string;
    environmentId: string;
    vaultId?: string | null;
    apiKeySecret?: string | null;
    // Only meaningful for a roster of exactly one; the coordinator pins its own version separately.
    version?: number | null;
    enableRls?: boolean | null;
}

/** Persists the desired multi-agent roster as the user's managed agent selection. */
export async function setMultiAgentRoster(
    roster: string[],
    displayName: string,
    dbConfig: ManagedAgentDbConfig,
    appApi: AppApi<unknown>
): Promise<void> {
    if (roster.length === 0) {
        throw new Error('Vælg mindst én agent i Agents tilstand');
    }

    const agentModel: AgentModel = {
        Name: displayName,
        Model: 'managed-agent',
        ModelCompany: 'Anthropic Managed',
        Organization: dbConfig.organization,
        EnvironmentId: dbConfig.environmentId,
        SubAgentRoster: roster,
        ...(dbConfig.vaultId && { VaultId: dbConfig.vaultId }),
        ...(dbConfig.apiKeySecret && {
            AnthropicApiKey: dbConfig.apiKeySecret
        }),
        ...(dbConfig.version != null && { Version: dbConfig.version }),
        ...(dbConfig.enableRls && { EnableRls: dbConfig.enableRls })
    } as AgentModel;

    await queueAgentSelectionPersist(() =>
        appApi.agent.setAgentOnUser({ agent: agentModel })
    );
}
